export const INSURANCE_TYPES = [
	{ label: 'Apple Care', value: 'apple_care' },
	{ label: 'Cover Plus', value: 'cover_plus' },
];
